// action types
export const STORE_EXPIRES_AT = "storeExpiresAt";
export const REMOVE_EXPIRES_AT = "removeExpiresAt";

// mutation types
export const SET_EXPIRES_AT = "setExpiresAt";

const state = {
  accessTokenExpiresAt: null
};

const getters = {
  accessTokenExpiresAt(state) {
    return state.accessTokenExpiresAt;
  }
};

const actions = {
  [STORE_EXPIRES_AT](context, expiresAt) {
    context.commit(SET_EXPIRES_AT, expiresAt);
  },
  [REMOVE_EXPIRES_AT](context) {
    context.commit(SET_EXPIRES_AT, null);
  }
};

const mutations = {
  [SET_EXPIRES_AT](state, expiresAt) {
    state.accessTokenExpiresAt = expiresAt;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
